<template>
  <div>
    <vue-snotify></vue-snotify>

    <ValidationObserver ref="form" v-slot="{ passes }">
      <b-form action="#" @submit.prevent="passes(updateProfile)">
        <!-- current password -->
        <ValidationProvider
          name="Current Password"
          rules="required"
          v-slot="{ errors }"
          vid="current_password"
        >
          <b-form-group>
            <b-row>
              <b-col cols="3">
                <span class="span">Current Password</span>
              </b-col>
              <b-col cols="5">
                <b-form-input
                  id="current_password"
                  type="password"
                  placeholder="Current Password"
                  class="form-control form-control-lg"
                  v-model="current_password"
                >
                </b-form-input>
              </b-col>
              <b-col cols="4">
                <div>
                  <div v-if="!errors[0]" class="color-box color-box-user-id">
                    <p>The Current Password field is required</p>
                  </div>
                  <div v-else class="color-box-v color-box-user-id-v">
                    <p v-for="(error, index) in errors" v-bind:key="index">
                      {{ error }}
                    </p>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-form-group>
        </ValidationProvider>

        <!-- password -->
        <ValidationProvider
          v-if="$can('Reset_Password_Own', 'all')"
          name="Password"
          rules="required"
          v-slot="{ errors }"
          vid="password"
        >
          <b-form-group>
            <b-row>
              <b-col cols="3">
                <span class="span">New Password</span>
              </b-col>
              <b-col cols="5">
                <b-form-input
                  id="password"
                  type="password"
                  placeholder="Password"
                  class="form-control form-control-lg"
                  v-model="password"
                >
                </b-form-input>
                <span style="color: #ffc107; font-size: 11px"
                  >Password must be at least 6 characters and contain at least 1
                  special character.</span
                >
              </b-col>
              <b-col cols="4">
                <div>
                  <div v-if="!errors[0]" class="color-box color-box-user-id">
                    <p>The New Password field is required</p>
                  </div>
                  <div v-else class="color-box-v color-box-user-id-v">
                    <p v-for="(error, index) in errors" v-bind:key="index">
                      {{ error }}
                    </p>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-form-group>
        </ValidationProvider>

        <!-- password confirmation-->
        <ValidationProvider
          v-if="$can('Reset_Password_Own', 'all')"
          name="Password Confirmation"
          rules="required|confirmed:password"
          v-slot="{ errors }"
          vid="confirmation"
        >
          <b-form-group>
            <b-row>
              <b-col cols="3">
                <span class="span">Password Confirmation</span>
              </b-col>
              <b-col cols="5">
                <b-form-input
                  id="password_confirm"
                  type="password"
                  placeholder="Password confirmation"
                  class="form-control form-control-lg"
                  v-model="confirmation"
                >
                </b-form-input>
              </b-col>
              <b-col cols="4">
                <div v-if="!errors[0]" class="color-box color-box-user-id">
                  <p>The Password Confirmation field is required</p>
                </div>
                <div v-else class="color-box-v color-box-user-id-v">
                  <p v-for="(error, index) in errors" v-bind:key="index">
                    {{ error }}
                  </p>
                </div>
              </b-col>
            </b-row>
          </b-form-group>
        </ValidationProvider>

        <!-- Create -->
        <b-row>
          <b-col cols="3">
            <span class="span"></span>
          </b-col>
          <b-col cols="5">
            <b-row>
              <b-col cols="6">
                <b-button type="submit" block variant="primary" size="lg"
                  >Update</b-button
                >
              </b-col>
              <b-col cols="6">
                <router-link to="/users">
                  <b-button block size="lg">Cancel</b-button>
                </router-link>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="4">
            <div></div>
          </b-col>
        </b-row>
      </b-form>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Snotify, { SnotifyPosition, SnotifyStyle } from "vue-snotify";
import { http } from "@/config/http";

export default {
  name: "UserProfile",
  data() {
    return {
      current_password: "",
      password: "",
      confirmation: "",
      user_name: "",
    };
  },
  methods: {
    async updateProfile() {
      this.user_id = 1;
      await http
        .post("/users/profile/update", {
          current_password: this.current_password,
          password: this.password,
          user_name: this.user_name,
        })
        .then((response) => {
          if (response.data.success) {
            this.$snotify
              .success(response.data.success.message, "Success!", {
                timeout: 2000,
                closeOnClick: false,
                pauseOnHover: true,
                position: SnotifyPosition.centerTop,
              })
              .on("destroyed", () => this.$router.push("/dashboard"));
            this.password = "";
            this.user_name = "";
            this.confirmation = "";
          } else if (response.data.error) {
            this.$refs.form.setErrors(response.data.error.details);
            this.$snotify.error(response.data.error.message, "Error!", {
              timeout: 2000,
              closeOnClick: false,
              pauseOnHover: true,
              position: SnotifyPosition.centerTop,
            });
          }
        });
    },
  },
};
</script>

<style scoped>
.disbled-card {
  pointer-events: none;
}

.small-text {
  color: #73818f;
}

.h1 {
  margin-bottom: 0rem !important;
}

.row-top {
  margin-top: 30px;
}

.row-bottom {
  margin-bottom: 50px;
}

.span {
  float: right;
  margin-top: 12px;
  color: #73818f;
  font-weight: 400;
}

::placeholder {
  color: #73818f;
  font-weight: 200;
  font-size: 14px;
  font-style: italic;
}

.role-row {
  margin-bottom: 20px;
}

.container {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.wrapper {
  margin: 0px !important;
}

.wrapper .container .bottom .left .details {
  padding: 10px 0 0 18px !important;
  width: calc(70% - 0px) !important;
}

.wrapper .container .bottom .left .add i {
  padding: 9px !important;
}

.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #ffffff;
  margin-top: 25px;
}

.wrapper .container .bottom .right .done i {
  padding: 10px !important;
}

.wrapper .container .bottom .right .details {
  padding: 10px !important;
  float: right;
  width: calc(70% - 4px) !important;
}

.wrapper .container .bottom .right .remove i {
  padding: 12px !important;
}

.wrapper .container .bottom .right .remove {
  height: 58% !important;
}

.role-card {
  margin-left: 12px;
}
</style>
